<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap >     
      <v-flex xs12 md6>
        <v-avatar size="25" class="light-blue lighten-1 elevation-5 mx-1"><v-icon fab xs-small dark @click.stop="goBack()">arrow_back</v-icon></v-avatar>
        <material-card color="green" title="Edit Profile" text="update your profile">
          <v-card-title>Personal Details</v-card-title>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-text-field label="Spouse FirstName" v-model="spouseJson.firstname" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field label="Spouse LastName" v-model="spouseJson.lastname" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field label="Spouse Email" v-model="spouseJson.emailid" class="purple-input" />
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field label="Spouse Phone" v-model="spouseJson.mobile" class="purple-input" />
                </v-flex>
                <v-flex xs12 text-xs-center>               
                              
                  <!-- <v-btn  class="mx-2 font-weight-light" color="info">Update Membership</v-btn>                    -->
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
      <v-flex xs12 md6>
        <material-card class="v-card-profile">
          <v-avatar slot="offset" class="mx-auto d-block" size="90">
            <img :src="require('@/assets/kids1.jpg')">
          </v-avatar>
          <v-card-text class="text-xs-center">
      <v-form>
        <v-container py-0>
          <v-layout wrap>
          <v-flex md12>
            <material-card color="green" title="Simple Table" text="Kids Table">
               <v-card-title>Kids Details</v-card-title>
              <v-data-table dense v-bind:headers="headers" v-bind:items="kidsList" item-key="_id" class="caption" :loading="loading" hide-default-footer>
                <!-- <template v-slot:item.enrolled="{ item }">
                      <v-chip small="true" :color="getColor(item.enrolled)" dark></v-chip>
                </template> -->
              </v-data-table>
            </material-card>
          </v-flex>            
          </v-layout>
        </v-container>
      </v-form>
      </v-card-text>
      </material-card>
      </v-flex>
    </v-layout>
     <v-layout row justify-center>
      <v-dialog v-model="profile" max-width="800px" max-height="1000px" hide-overlay>
        <v-toolbar color="light-green lighten-2" height="65">
          <v-toolbar-title class="body-2">Update Personal Data</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" v-model="valid" :close-on-content-click="false" :nudge-right="100" offset-y full-width>
          <v-card>
            <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" dense class="body-2 mr-2" box v-model="Json.primaryemail" label="Primary Email" placeholder=" " height="25" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" dense class="body-2 mr-2" box v-model="Json.membershipcategory" label="Membership Category" placeholder=" " height="25" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" dense class="body-2 mr-2" box v-model="Json.paymentstatus" label="Payment Status" placeholder=" " height="25" disabled></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" dense class="body-2 mr-2" box ref="Json.firstname"  v-model="Json.firstname" label="First Name" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field  :rules="nameRules" dense class="body-2 mr-2" box ref="Json.lastname" v-model="Json.lastname" label="Last Name" placeholder=" " height="25" ></v-text-field>
                        </v-flex>                        
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" dense class="body-2 mr-2" box ref="Json.mobile" v-model="Json.mobile" label="Mobile" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                       <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" dense class="body-2 mr-2" box ref="Json.address" v-model="Json.address" label="Address" placeholder=" " height="25" ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" dense filled class="body-2 mr-2" box ref="spouseJson.firstname" v-model="spouseJson.firstname" label="Spouse FirstName" placeholder=" " height="25" ></v-text-field>
                        </v-flex> 
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" dense filled class="body-2 mr-2" box ref="spouseJson.lastname" v-model="spouseJson.lastname" label="Spouse LastName" placeholder=" " height="25" ></v-text-field>
                        </v-flex>                   
                        <v-flex xs12 sm6 md4>
                          <v-text-field :rules="nameRules" dense filled class="body-2 mr-2" ref="Json.emailid" v-model="spouseJson.emailid" label="Spouse Email"  box placeholder=" " height="25" ></v-text-field>
                        </v-flex> 
                        <v-flex xs12 md4>
                          <v-text-field  label="Spouse Phone"  box placeholder=" " height="25" ref="spouseJson.mobile" v-model="spouseJson.mobile" class="purple-input" />
                        </v-flex>                                               
                        </v-layout>
                    </v-container>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline color="light-green lighten-3" @click="close">Close</v-btn>
              <v-btn small outline color="light-green lighten-2" @click="updatePersonalData()" :disabled="!valid">Update</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="kidPopup" max-width="800px" max-height="1000px" hide-overlay>
        <v-toolbar color="light-green lighten-2" height="65">
          <v-toolbar-title class="body-2">Add Kids</v-toolbar-title>
        </v-toolbar>
        <v-form ref="form" v-model="valid" :close-on-content-click="false" :nudge-right="100" offset-y full-width>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>                                            
              <v-flex xs12 sm6 md8>
                <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="KidsJson.firstname" label="First Name" placeholder=" " height="25" ></v-text-field>
              </v-flex>
               <v-flex xs12 sm6 md8>
                <v-text-field :rules="nameRules" class="body-2 mr-2" box v-model="KidsJson.lastname" label="Last Name" placeholder=" " height="25" ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3>
                <v-autocomplete outlined dense placeholder=" " label="Select KidsAge" box v-model="KidsJson.age" :items="['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21']" ></v-autocomplete>
              </v-flex> 
              <v-flex xs12 sm6 md3>
                <v-autocomplete outlined dense placeholder=" " label="Gender" box v-model="KidsJson.gender" :items="['Female','Male']"></v-autocomplete>
              </v-flex>                                               
            </v-layout>
          </v-container>
          </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small outline color="light-green lighten-3" @click="close">Close</v-btn>
              <v-btn  v-if="KidsJson.gender != '' && KidsJson.age!='' && KidsJson.firstname!='' && KidsJson.lastname!=''" small outline color="light-green lighten-2" @click="addKid()" :disabled="!valid">Add Kid</v-btn>
              <v-btn  v-if="KidsJson.gender === '' && KidsJson.age==='' && KidsJson.firstname==='' && KidsJson.lastname===''" small outline color="light-green lighten-3" :disabled="!valid">Fill All Data</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import ReportServices from '@/services/ReportServices'

export default {
  data: () => ({email: undefined,
      form: false,
      isLoading: false,
      loading:false,
      valid: true,
      popup: false,
      profile:false,
      loggedInPerson:'',
      profiledata:'',
      kidPopup:false,
      kidsList:[],
      kid:[],
      spouse: {},
      Json:{},
      spouseJson:{},
      spouseData:{},
     KidsJson: {        
        firstname: '',
        lastname: '',
        age: '',
        gender: '',
        familyId:'',
        membershipcategory:'',
        paymentstatus:'',
      },
      rules: {
        email: v => (v || '').match(/@/) || 'Please enter a valid email',
        length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
        password: v => (v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) || 'Password must contain an upper case letter, a numeric character, and a special character',
        required: v => !!v || 'This field is required',
      },
    headers: [
      {sortable: false,text: 'First Name', value: 'firstname'},
      {sortable: false,text: 'Last Name',value: 'lastname'},
      {sortable: false,text: 'Age',value: 'age'},
      {sortable: false, text: 'Gender', value: 'gender',align: 'right'}
    ],
  }),
   methods: {
      close () {
      this.profile = false
      this.kidPopup = false
      setTimeout(() => {
        this.refresh() }, 100)
    },
    async updateProfile() {
    this.profile= true
    },
    async addNewkid() {
      this.kidPopup = true      
    },
    goBack () {
      this.$router.go(-1)
    },
     async updatePersonalData() {
     this.Json.updateTimeStamp=new Date().toLocaleDateString('en-US', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'})
     await ReportServices.updatePersonalData(this.Json)
     if(this.spouseJson._id==null)
        {
          const ObjectId = (m = Math, d = Date, h = 16, s = s => m.floor(s).toString(h)) =>
          s(d.now() / 1000) + ' '.repeat(h).replace(/./g, () => s(m.random() * h))
          this.spouseJson._id=ObjectId
          this.spouseJson.familyId=this.Json._id
          this.spouseJson.membershipcategory=this.profiledata.membershipcategory
          this.spouseJson.paymentstatus=this.profiledata.paymentstatus
          await ReportServices.createSpouseData(this.spouseJson)
          }
      else
       {
         this.spouseJson.membershipcategory=this.Json.membershipcategory
          this.spouseJson.paymentstatus=this.Json.paymentstatus
         await ReportServices.updateSpouseData(this.spouseJson)
       }
       setTimeout(() => {
         this.profile= false
       this.refresh()}, 200)
    },
     async addKid() {     
      this.KidsJson.familyId=this.profiledata._id
      this.KidsJson.membershipcategory=this.profiledata.membershipcategory
      this.KidsJson.paymentstatus=this.profiledata.paymentstatus
      await ReportServices.addKid(this.KidsJson)
      setTimeout(() => {
         this.kidPopup = false
         this.refresh()}, 200)      
    },
    async refresh () {
      this.loading = true
      this.spouseData = (await ReportServices.getSpouseByFamilyId(this.$route.params.id)).data
      this.kidsList = (await ReportServices.KidsByFamilyId(this.$route.params.id)).data
      this.Json= this.profiledata
      if(this.spouseData!=null)
       {this.spouseJson= this.spouseData

       } 
      this.loading = false
      this.noDataText = 'No data available'
    }
  },
  async mounted () {
    this.refresh()
  }
}
</script>
